import { Owned } from '../base/named';
import { Metamodel } from '../base/model';
import { IdGenerationUtils } from './id-generation-utilities';

import { DataFlowExpression } from './dataflowexpression';
import { IViolation } from '../base/annotation';
import { ModelMarkerWrapper } from 'app/shared/utils/model-marker-wrapper';

@Metamodel.model({
    name: 'expressionBasedColumnBase',
    abstract: true
})
export abstract class ExpressionBasedColumnBase extends Owned {

    private _displayId = IdGenerationUtils.generateUniqueId();
    public rowIndex: number;
    public get displayIdentifier(): number {
        return this._displayId;
    }

    protected static expressionIsNotEmptyValidator(mapColumn: ExpressionBasedColumnBase, expression: DataFlowExpression): IViolation[] | undefined {
        if (!expression.expression) {
            return [{
                context: mapColumn,
                message: () => stringResources.DataFlowColumnExpressionRequiredError
            }];
        }
        return undefined;
    }

    public abstract markDelete(modelMarkerWrapper: ModelMarkerWrapper): void;
}
